import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    num: 2,
    indexDownloade: 0,
    sisterindex: 0,
    travelIndex:0,
    teachIndex:0,
    resourceproIndex:0,
  },//存放状态
  mutations: {
    editTitle(state, value) {
      state.num = value.num;
    },
    editindexDownloade(state, value) {
      state.indexDownloade = value.num;
    },
    editsisterindex(state, value) {
      state.sisterindex = value.num;
    },
    edittravelIndex(state, value) {
      state.travelIndex = value.num;
    },
    editteachIndex(state, value) {
      state.teachIndex = value.num;
    },
    editresourceproIndex(state, value) {
      state.resourceproIndex = value.num;
    },
  },//更改状态的逻辑，同步操作
  actions: {

  },//更改mutations，异步操作
  modules: {
  }//将store模块化
})
